import * as React from "react";
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.JSX.Element;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  if (localStorage.getItem("access_token") != null) {
    return outlet;
  } else {
    const url = `${window.location.protocol}//${window.location.host}/login`;
    localStorage.clear();
    window.location.assign(url);
    return outlet;
  }
}
